import { render } from "./Buy.vue?vue&type=template&id=3c4d9162&scoped=true"
import script from "./Buy.vue?vue&type=script&lang=js"
export * from "./Buy.vue?vue&type=script&lang=js"

import "./Buy.vue?vue&type=style&index=0&id=3c4d9162&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-3c4d9162"

export default script